export default "__VITE_ASSET__Ccv6fTfZ__"